module.exports = __webpack_public_path__ + "img/kkgqjj_img.e56a63ac.png";